import {MensajesActions, MensajesActionTypes} from './mensajes.actions';
import {initialState, mensajesAdapter, MensajesState} from './mensajes.state';

export function mensajesReducer(state = initialState, action: MensajesActions): MensajesState {
  switch (action.type) {
    // load
    case MensajesActionTypes.MENSAJES_LOAD_REQUEST: {
      return {
        ...state,
        isLoading: true,
        error: null
      };
    }
    case MensajesActionTypes.MENSAJES_LOAD_SUCCESS: {
      return mensajesAdapter.addMany(action.payload.items, {
        ...state,
        isLoading: false,
        error: null
      });
    }
    case MensajesActionTypes.MENSAJES_LOAD_FAILURE: {
      return {
        ...state,
        isLoading: false,
        error: action.payload.error
      };
    }
    // add
    case MensajesActionTypes.MENSAJES_ADD_REQUEST: {
      return {
        ...state,
        isLoading: true,
        error: null
      };
    }
    case MensajesActionTypes.MENSAJES_ADD_SUCCESS: {
      return mensajesAdapter.addOne(action.payload.item, {
        ...state,
        isLoading: false,
        error: null
      });
    }
    case MensajesActionTypes.MENSAJES_ADD_FAILURE: {
      return {
        ...state,
        isLoading: false,
        error: action.payload.error
      };
    }
    // default
    default: {
      return state;
    }
  }
}
